import { CartDetailDTO, CartSummaryDTO } from 'src/app/core/models/shopping-cart';
import { ShoppingCartActions, ShoppingCartActionTypes, TempShoppingCartActions } from './shopping-cart.action';

export interface TempShoppingCartState {
  tempShoppingCartDetails: CartDetailDTO[];
  idMember: number;
  error: string;
}

const initialState: TempShoppingCartState = {
  tempShoppingCartDetails: [],
  idMember: undefined,
  error: '',
};

export function tempShoppingCartReducer(state = initialState, action: TempShoppingCartActions): TempShoppingCartState {
  switch (action.type) {
    case ShoppingCartActionTypes.TEMP_SHOPPINGCART_LOAD_SUCCESS:
    case ShoppingCartActionTypes.TEMP_SHOPPINGCART_LOAD_UPDATE:
      return {
        ...state,
        tempShoppingCartDetails: action.data,
        error: '',
      };
    case ShoppingCartActionTypes.TEMP_SHOPPINGCART_LOAD_FAIL: {
      return Object.assign({}, state, {
        error: action.data.error,
      });
    }
    default:
      return state;
  }
}

export interface ShoppingCartState {
  shoppingCartSummary: CartSummaryDTO[];
  idMember: number;
  error: string;
}

const shoppingCartInitialState: ShoppingCartState = {
  shoppingCartSummary: [],
  idMember: undefined,
  error: '',
};

export function shoppingCartReducer(state = shoppingCartInitialState, action: ShoppingCartActions): ShoppingCartState {
  switch (action.type) {
    case ShoppingCartActionTypes.SHOPPINGCART_LOAD_SUCCESS:
    case ShoppingCartActionTypes.SHOPPINGCART_LOAD_UPDATE:
      return {
        ...state,
        shoppingCartSummary: action.data,
        error: '',
      };
    case ShoppingCartActionTypes.SHOPPINGCART_LOAD_FAIL: {
      return Object.assign({}, state, {
        error: action.data.error,
      });
    }
    default:
      return state;
  }
}
